<template>
    <div class="setup-account" style="height: 100%">
        <!--<div class="top-header">
            <div>
                <img src="@/assets/logo-fff-small.png" />
                <div>
                    <span class="welcome">
                        Welcome<strong> {{ name }}</strong>
                    </span>
                    &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;
                    <span class="logout" @click="logout"><i class="fa fa-sign-out-alt"></i> Logout</span>
                </div>
            </div>
        </div>-->
        <div class="security-question" v-if="account_type == 1">
            <div class="setup">
                <p class="mb-5"><img src="../../public/logo-small.png" /></p>
                <h3>Set your security question.</h3>
                <p>Secure your account one step better by setting a 2FA. <br/>You can turn on/off 2FA on your settings page.</p>
                <form class="form" @keypress="sendquestion" @submit.prevent>
                    <div>
                        <label>Security Question</label>
                        <input type="text" v-model="question" placeholder="Enter your security question">
                        <span class="error" v-if="error.question">Please enter your choosen security question</span>
                    </div>
                    <div>
                        <label>Your Answer</label>
                        <input type="password" v-model="answer" placeholder="Security question answer">
                        <span class="error" v-if="error.answer">Please enter your security question answer</span>
                    </div>
                    <div class="submit d-flex justify-content-between flex-row">
                      <button type="button" @click="skip_security_question">Skip</button>
                      <button type="button" @click="submit">Continue</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="security-question" v-if="account_type == 2 && isStaff">
            <div class="setup" v-if="next == 1">
                <p class="mb-5"><img src="../../public/logo-small.png" /></p>
                <h3>Set your security question.</h3>
                <p>Secure your account one step better by setting a 2FA. <br/>You can turn on/off 2FA on your settings page.</p>
                <form class="form" @keypress="sendquestion" @submit.prevent>
                    <div>
                        <label>Security Question</label>
                        <input type="text" v-model="question" placeholder="Enter your security question">
                        <span class="error" v-if="error.question">Please enter your choosen security question</span>
                    </div>
                    <div>
                        <label>Your Answer</label>
                        <input type="password" v-model="answer" placeholder="Security question answer">
                        <span class="error" v-if="error.answer">Please enter your security question answer</span>
                    </div>
                    <div class="submit d-flex justify-content-between flex-row">
                      <button type="button" @click="skip_security_question">Skip</button>
                      <button type="button" @click="submit">Continue</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="security-question" v-if="account_type == 2 && isSuperAdmin && !isAssigned" :class="{'adding-user': next == 4}">
            <div class="toastr animated animate" v-if="close_toastr" :class="{'slideInRight': close_toastr, 'slideOutRight': !close_toastr }">
                <h4>Success
                    <span class="closebtn" @click="closetoastr">
                        &times;
                    </span>
                </h4>
                <p v-if="company_update">
                  Organisation details updated successfully
                </p>
                <p v-if="department_added">
                  Department created successfully
                </p>
                <p v-if="user_added">
                  User created successfully
                </p>
                <p v-if="department_edited">
                  Department created successfully
                </p>
                <p v-if="user_edited">
                  User created successfully
                </p>
            </div>
            <div class="setup" v-if="next == 1">
                <p class="mb-5"><img src="../../public/logo-small.png" /></p>
                <h3>Set your security question</h3>
                <p>Secure your account one step better by setting a 2FA. <br/>You can turn on/off 2FA on your settings page.</p>
                <form class="form" @keypress="sendquestion" @submit.prevent>
                    <div>
                        <label>Security Question</label>
                        <input type="text" v-model="question" placeholder="Enter your security question">
                        <span class="error" v-if="error.question">Please enter your choosen security question</span>
                    </div>
                    <div>
                        <label>Security Question Answer</label>
                        <input type="password" v-model="answer" placeholder="Security question answer">
                        <span class="error" v-if="error.answer">Please enter your security question answer</span>
                    </div>
                    <div class="submit d-flex justify-content-between flex-row">
                      <button type="button" @click="skip_security_question">Skip</button>
                      <button type="button" @click="submit">Continue</button>
                    </div>
                </form>
            </div>
            <div class="setup-name add-employee" v-if="next == 2">
                <p class="mb-4"><img src="../../public/logo-small.png" /></p>
                <h3 class="m-0">Add your organisation details.</h3>
                <p class="mb-3">Fill in the information related to your organization according to the form below.</p>
                <form class="form" @submit.prevent>
                    <div class="row">
                      <div class="col-sm-12 col-md-12">
                        <label class="mb-2"><strong>Organisation Name</strong></label>
                        <input type="text" v-model="company_name" placeholder="Enter your organisation name" />
                        <span class="error" v-show="error.name">*Required</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <label class="form-label mb-2"><strong>Country</strong></label>
                        <select v-model="country" class="d-block">
                            <option value="">Select Country</option>
                            <option v-for="(country, index) in countries" :value=country.name :key="index">{{ country.name }}</option>
                        </select>
                        <span class="error" v-if="error.country">*Required</span>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <label class="mb-2"><strong>City</strong>(optional)</label>
                        <input type="text" class="full" v-model="company_address_city" placeholder="Enter city" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-12">
                        <label class="mb-2"><strong>Address</strong>(optional)</label>
                        <input type="text" v-model="company_address" placeholder="Enter address" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-12">
                        <label class="mb-2"><strong>Phone Number</strong>(optional)</label>
                        <input type="text" class="full" v-model="company_phone" placeholder="Enter phone number" />
                      </div>
                    </div>
                    <div class="submit">
                        <button type="button" @click="submit_company_details">Continue</button>
                    </div>
                </form>
            </div>
            <div class="fdepartment row" v-if="next == 3" style="justify-content: center">
                <div class="setup-name col-sm-12 col-md-6" :style="{'margin-left: auto;margin-right: auto;': true}" v-if="next == 3">
                    <div class="department-setup">
                      <p class="mb-4"><img src="../../public/logo-small.png" /></p>
                      <h3 class="m-0" style="font-size: 24px">Add your organisation departments</h3>
                      <p class="mb-3">Add departments that will collaborate within your organization and create folders for each departments.</p>
                      <form class="form" @submit.prevent>
                        <div class="input">
                          <label><strong>Department Name</strong></label>
                          <span class="d-flex flex-row">
                            <input type="text" v-model="department_name" placeholder="Enter department name" />
                            <span class="add-btn" @click="submit_create_department">
                              <img src="@/assets/Plus.svg" />&nbsp;
                              Add
                            </span>
                          </span>
                          <span class="error" v-if="error.department_name">*Required</span>
                          <span class="error" v-if="error.department_name_exist">*Department already created</span>
                          <span class="mt-2 d-block">
                            <label name="create_folder" style="font-weight: normal;" class=""><input type="checkbox" name="create_folder" v-model="create_folder" class="" /> &nbsp;Create a folder for this department in group folder</label>
                          </span>
                        </div>
                        <ul v-if="departments.length" class="dept-lists" :class="{'dept-lists-height':departments.length > 2}">
                          <li v-for="(department, index) in departments" :key="index">
                            <div v-if="!department.edit_mode" class="d-flex justify-content-between">
                                <span class="dept-box px-3">{{ department.name }}</span>
                                <span class="action d-flex justify-content-center align-items-center">
                                    <span @click="edit_text(index)" style="cursor:pointer">
                                      <img src="@/assets/Edit.svg" />
                                    </span>
                                    &nbsp;
                                    <span @click="delete_text(index)" style="cursor:pointer">
                                      <img src="@/assets/Gray-Delete-Btn.svg" />
                                    </span>
                                </span>
                            </div>
                            <div v-if="department.edit_mode" class="d-flex justify-content-between">
                                <input type="text" class="edit_text px-3" v-model="text" ref="edit" />
                                <span class="action2 d-flex justify-content-center align-items-center" style="margin-left:10px">
                                    <span @click="save_text(index)" style="cursor:pointer">
                                      <img src="@/assets/Save-Btn.svg" />
                                    </span>
                                    &nbsp;
                                    <span @click="cancel_text(index)" style="cursor:pointer">
                                      <img src="@/assets/Cancel-Btn.svg" />
                                    </span>
                                </span>
                            </div>
                          </li>
                        </ul>
                        <div class="submit" style="margin-top:0">
                          <span class="skip" @click="skip">Continue</span>
                        </div>
                      </form>
                    </div>
                </div>
            </div>
            <div class="add-employee user-adding row" v-if="next == 4">
                <div class="setup-name add-user col-sm-12 col-md-6">
                    <p class="mb-4"><img src="../../public/logo-small.png" /></p>
                    <h3 class="m-0">Add user and allocate space</h3>
                    <p class="mb-3" style="font-size: 15px;">Add your users, this can be your employees or project team. Users you add are part of your organization on Fexspace.</p>
                    <p class="d-flex justify-content-center align-items-center my-5" v-if="!users.length">
                      <span class="add-user-icon">
                        <img src="@/assets/UserBox.svg" width="17px" height="17px" />
                        <img src="@/assets/Plus2.svg" width="16px" height="16px" />
                      </span>
                    </p>
                    <ul v-if="users.length" :class="{'dept-lists-height':users.length > 2}">
                      <li v-for="(user, index) in users" :key="index" class="d-flex justify-evenly flex-row" :class="{'mb-3': index != (users.length - 1)}">
                            <div class="avatar2 mr-3">
                                <span>
                                  <img src="@/assets/UserBox.svg" width="17px" height="17px" />
                                </span>
                            </div>
                            <div class="data d-flex flex-row justify-content-between flex-grow-1">
                                <div class="d-flex flex-column">
                                    <span class="name">
                                      <strong>{{ user.firstname + ' ' + user.lastname }}</strong>
                                    </span>
                                    <span class="dept">
                                      {{ user.department }}
                                    </span>
                                </div>
                                <div class="d-flex flex-row justify-content-between align-items-center">
                                    <span class="action">
                                        <span @click="edit_user(index)" style="cursor: pointer">
                                          <img src="@/assets/Edit.svg" />
                                        </span>
                                        &nbsp;
                                        <span @click="delete_user(index)" style="cursor: pointer">
                                          <img src="@/assets/Gray-Delete-Btn.svg" width="17px" height="17px" />
                                        </span>
                                    </span>
                                </div>
                            </div>
                      </li>
                    </ul>
                    <div class="d-flex flex-column">
                      <span class="add-user-btn" @click="add_user_func">
                        <img src="@/assets/Plus2.svg" />&nbsp;&nbsp;
                        <span>Add User</span>
                      </span>
                      <span class="skip-btn" @click="go_dashboard">
                        Skip & Continue
                      </span>
                    </div>
                </div>
            </div>
        </div>
        <loading ref="loading"></loading>
        <warning ref="warning"></warning>
        <editdepartmentload ref="editloader"></editdepartmentload>
        <editusermodal ref="edituser"></editusermodal>
        <login ref="login"></login>
        <notify ref="notify"></notify>
        <logout ref="logout"></logout>
        <add-user-func ref="add_user_func"></add-user-func>
        <edit-user-func ref="edit_user_func"></edit-user-func>
    </div>
</template>
<style scoped>
  .security-question .setup-name {
    background: transparent !important;
  }
  .user-adding ul {
    margin-bottom: 2.5em;
    margin-top: 1em;
  }
  .user-adding .avatar2 {
    display: inline-flex;
    width: 48px !important;
    height: 48px !important;
    background-color: #E8F0F6 !important;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .user-adding .dept {
    font-family: 'DM Sans';
    font-size: 13px;
    color: #677888 !important;
  }
  .user-adding .name {
    font-family: 'DM Sans';
    font-size: 20px;
    color: #111 !important;
  }
  .add-user-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #E8F0F6;
  }
  .user-adding .add-user-btn {
    cursor: pointer;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #3F96D1;
    border-radius: 8px;
    color: #3F96D1;
    background-color: #fff;
    margin-bottom: 20px;
    font-family: 'DM Sans';
    font-size: 15px;
    width: 100%;
  }
  .user-adding .skip-btn {
    cursor: pointer;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #3F96D1;
    border-radius: 8px;
    font-family: 'DM Sans';
    color: #fff;
  }
  .adding-user {
    height: 100% !important;
  }
  .adding-user .user-adding .setup-name {
    height: 100% !important;
  }
  .user-adding .setup-name {
    padding: 0 !important;
    margin: 0 auto !important;
  }
  .user-adding .add-user {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .dept-lists-height {
    height: 200px;
    overflow-y: auto;
  }
  .dept-lists {
    margin-top: 2em;
    margin-bottom: 0 !important;
  }
  .dept-box {
    border: 1px solid #A7B9CB;
    border-radius: 8px;
    height: 56px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    color: #111111;
    font-family: 'DM Sans';
    margin-right: 10px;
  }
  .department-setup .submit span {
    cursor: pointer;
    background-color: #3F96D1;
    height: 56px;
    border-radius: 8px;
    color: #fff !important;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: normal;
    font-family: 'DM Sans';
  }
  .add-btn {
    cursor: pointer;
    height: 56px;
    width: 140px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #3F96D1;
    margin-left: 10px;
    color: #fff !important;
  }
  .setup .submit button {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }
  .setup .submit button:nth-child(1) {
    margin-right: 10px;
    background-color: #fff !important;
    border: 1px solid #3F96D1 !important;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
    color: #3F96D1 !important;
  }
  .setup .submit button:nth-child(2) {
    background-color: #3F96D1 !important;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
  }
  .setup {
    background-color: transparent !important;
    border: none !important;
  }
  .setup h3 {
    font-family: 'Larsseit' !important;
    font-size: 32px;
    margin-bottom: 20px;
    font-weight: 700;
    color: #111111 !important;
  }
  .setup p {
    font-family: 'DM Sans';
    color: #4B5458 !important;
    font-size: 16px;
    line-height: 22.4px;
  }
  .setup form {
    text-align: left;
  }
  .setup form label {
    font-family: 'DM Sans';
    color: #677888 !important;
    font-size: 16px !important;
  }
  .setup form input {
    border: 1px solid #A7B9CB !important;
    background-color: #fff !important;
    font-size: 15px !important;
    padding: 1em .9em !important;
    text-align: left !important;
    font-family: 'DM Sans' !important;
    border-radius: 8px !important;
  }

  .setup-name .submit button {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }
  .setup-name .submit button {
    background-color: #3F96D1 !important;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
  }
  .setup-name {
    border: none !important;
  }
  .setup-name h3 {
    font-family: 'Larsseit' !important;
    font-size: 32px;
    margin-bottom: 20px;
    font-weight: 700;
    color: #111111 !important;
  }
  .setup-name p {
    font-family: 'DM Sans';
    color: #4B5458 !important;
    font-size: 16px;
    line-height: 22.4px;
  }
  .setup-name form {
    text-align: left;
  }
  .setup-name form label {
    font-family: 'DM Sans';
    color: #677888 !important;
    font-size: 16px !important;
  }
  .setup-name form input {
    border: 1px solid #A7B9CB !important;
    background-color: #fff !important;
    font-size: 15px !important;
    padding: 1em .9em !important;
    text-align: left !important;
    font-family: 'DM Sans' !important;
    border-radius: 8px !important;
  }
  .setup-name form select {
    border: 1px solid #A7B9CB !important;
    background-color: #fff !important;
    font-size: 15px !important;
    padding: 1em .9em !important;
    text-align: left !important;
    font-family: 'DM Sans' !important;
    border-radius: 8px !important;
  }
  .security-question {
    background-color: #fff;
  }
    input[type="checkbox"] {
      border: 1px solid #ccc;
      width: auto !important;
      display: inline !important;
    }
    .security-question .setup {
      padding: 1.8em !important;
    }
    .security-question .setup .form {
      width: auto;
    }
    .add-employee {
      flex-direction: column;
    }
    .user-adding {
      flex-direction: row !important;
    }
    .input div {
      flex-flow: 1 !important;
      margin-left: 10px;
    }
    .input div:first-child {
      margin-left: 0 !important;
    }

    .not div {
      margin-left: 0 !important;
    }

    .not div input {
      margin-right: 10px !important;
    }

</style>

<script>
import loading from '@/components/Loading'
import editdepartmentload from '@/components/Edit-Department-Loading'
import editusermodal from '@/components/Edit-User-Modal'
import AuthenticationService from '../services/AuthenticationService'
import countries from '@/countries'
import login from '@/components/Login'
import logout from '@/components/Logout'
import warning from '@/components/Warning'
import notify from '@/components/Notify'
import { setTimeout } from 'timers'
import axios from 'axios'
import cookies from '@/services/cookies'
import AddUserFunc from '@/components/Add-User-Func'
import EditUserFunc from '@/components/Edit-User-Func'

export default {
  components: {
    AddUserFunc,
    EditUserFunc,
    loading,
    login,
    warning,
    notify,
    editdepartmentload,
    editusermodal,
    logout
  },
  data () {
    return {
      isAssigned: false,
      isSuperAdmin: false,
      isStaff: false,
      isFirstTime: false,
      isPasswordChange: false,
      text: '',
      company_name: '',
      company_phone: '',
      company_address: '',
      company_address_city: '',
      department_name: '',
      country: '',
      create_folder: false,
      question: '',
      answer: '',
      total_space: 0,
      total_space_remaining: 0,
      total_space_used: 0,
      total_user_used_space: 0,
      error: {
        name: false,
        country: false,
        department_name: false,
        department_name_exist: false,
        question: false,
        answer: false,
        password: false,
        con_password: false,
        first_name: false,
        last_name: false,
        format: false,
        email: false,
        password_length: false,
        con_password_length: false,
        user_department: false,
        user_email_exist: false,
        current_password: false,
        new_password: false,
        confirm_new_password: false,
        confirm_new_password_mismatch: false,
        confirm_new_password_length: false,
        new_password_length: false,
        current_password_error: false
      },
      user_department: '',
      department: '',
      departments: [],
      name: '',
      post: true,
      account_type: '',
      countries: countries,
      department_created: false,
      next: 4,
      last_name: '',
      first_name: '',
      email: '',
      password: '',
      con_password: '',
      phone: '',
      size: 100,
      unit: 'MB',
      is_disable: false,
      tag: 0,
      space_error: false,
      users: [],
      new_password: '',
      confirm_new_password: '',
      current_password: '',
      company_update: false,
      department_added: false,
      department_edited: false,
      user_added: false,
      user_edited: false,
      close_toastr: false,
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    add_user_func () {
      this.$refs.add_user_func.load()
    },
    add_new_user (data, unit, size, isDisable, isAdmin) {
      this.$refs.loading.close()
      this.user_added = true
      this.close_toastr = true

      let that = this

      setTimeout(function () {
        that.user_added = false
        that.close_toastr = false
      }, 3500)
      this.users.push({
        _id: data._id,
        email: data.data.email,
        firstname: data.data.name.first,
        lastname: data.data.name.last,
        phone: data.data.phone,
        department: data.department,
        department_id: data.data.department_id,
        size: isDisable ? 'Unlimited' : size,
        unit: unit,
        is_admin: isAdmin,
        edit_mode: false
      })
    },
    logout () {
      this.$refs.logout.logout()
    },
    logincall () {
      this.$router.push('login')
    },
    closetoastr () {
      this.close_toastr = !this.close_toastr
    },
    revertSize () {
      this.size = 100
    },
    skip_security_question () {

      this.$refs.loading.load()
      let that = this
      let data = {
        token: cookies.getCookie('temp_token')
      }

      AuthenticationService.skipsetsecurity(data).then(res => {
        if (res.data.data == true) {
          if (that.account_type == 1) {
            if (process.env.VUE_APP_NODE_ENV === 'development') {
              that.$router.push('/')
            } else {
              if (
                cookies.getCookie("redirect") !== "" &&
                cookies.getCookie("redirect") !== null &&
                cookies.getCookie("redirect") !== undefined
              ) {
                window.location.replace(cookies.getCookie("redirect"));
              } else {
                window.location = "https://app.fexspace.com";
              }
            }
          }

          if (that.account_type == 2) {
            if (that.isStaff) {
              // that.$refs.loading.close()
              if (process.env.VUE_APP_NODE_ENV === 'development') {
                that.$router.push('/')
              } else {
                if (
                  cookies.getCookie("redirect") !== "" &&
                  cookies.getCookie("redirect") !== null &&
                  cookies.getCookie("redirect") !== undefined
                ) {
                  window.location.replace(cookies.getCookie("redirect"));
                } else {
                  window.location = "https://app.fexspace.com";
                }
              }
            } else {
              if (that.isSuperAdmin) {
                // that.$refs.loading.close()
                that.next = 2
              }
            }
          }
        }

        if (res.data.result == false) {
          that.$router.push('login')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    sendpassword (evt) {
      if (evt.keyCode === 13) {
        this.post = true
        this.error.current_password_error = false

        if (this.new_password === '') {
          this.error.new_password = true
          this.post = false
        } else {
          this.error.new_password = false
          if (this.new_password.length < 8) {
            this.error.new_password_length = true
          } else {
            this.error.new_password_length = false
          }
        }

        if (this.confirm_new_password === '') {
          this.error.confirm_new_password = true
          this.post = false
        } else {
          this.error.confirm_new_password = false
          if (this.confirm_new_password.length < 8) {
            this.error.confirm_new_password_length = true
          } else {
            this.error.confirm_new_password_length = false
          }
        }

        if (this.new_password !== this.confirm_new_password) {
          this.error.confirm_new_password_mismatch = true
          this.post = false
        } else {
          this.error.confirm_new_password_mismatch = false
        }

        if (this.post) {
          this.$refs.loading.load()

          let data = {
            token: cookies.getCookie('temp_token'),
            new_password: this.new_password
          }

          let that = this

          AuthenticationService.verifypassword(data).then(res => {
            if (res.data.data === true) {
              that.$refs.loading.close()
              that.next = 2
            }

            if (res.data.error === true) {
              that.$refs.loading.close()
              that.error.current_password_error = true
            }

            if (res.data.data === false) {
              that.$router.push('login')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    change_password () {
      this.post = true
      this.error.current_password_error = false

      if (this.new_password === '') {
        this.error.new_password = true
        this.post = false
      } else {
        this.error.new_password = false
        if (this.new_password.length < 8) {
          this.error.new_password_length = true
        } else {
          this.error.new_password_length = false
        }
      }

      if (this.confirm_new_password === '') {
        this.error.confirm_new_password = true
        this.post = false
      } else {
        this.error.confirm_new_password = false
        if (this.confirm_new_password.length < 8) {
          this.error.confirm_new_password_length = true
        } else {
          this.error.confirm_new_password_length = false
        }
      }

      if (this.new_password !== this.confirm_new_password) {
        this.error.confirm_new_password_mismatch = true
        this.post = false
      } else {
        this.error.confirm_new_password_mismatch = false
      }

      if (this.post) {
        this.$refs.loading.load()

        let data = {
          token: cookies.getCookie('temp_token'),
          new_password: this.new_password
        }

        let that = this

        AuthenticationService.verifypassword(data).then(res => {
          if (res.data.data === true) {
            that.$refs.loading.close()
            that.next = 2
          }

          if (res.data.error === true) {
            that.$refs.loading.close()
            that.error.current_password_error = true
          }

          if (res.data.data === false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    edit_text (index) {
      this.departments.map(d => {
        d.edit_mode = false
      })
      this.text = this.departments[index].name
      this.departments[index].edit_mode = true
      this.$refs.edit[index].autofocus = true
    },
    delete_text (index) {
      this.$refs.loading.load()

      let data = {
        id: this.departments[index]._id,
        token: cookies.getCookie('temp_token')
      }

      let that = this

      AuthenticationService.delete_department(data).then(res => {
        if (res.data.data === true) {
          that.$refs.loading.close()
          that.departments.splice(index, 1)
        }

        if (res.data.result === false) {
          that.$router.push('login')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    save_text (index) {
      this.$refs.editloader.load()

      let data = {
        id: this.departments[index]._id,
        token: cookies.getCookie('temp_token'),
        name: this.text
      }

      let that = this

      AuthenticationService.edit_department(data).then(res => {
        if (res.data.data == true) {
          that.$refs.editloader.close()
          that.departments[index].name = that.text
          that.departments[index].edit_mode = false
        }

        if (res.data.result == false) {
          that.$router.push('login')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    cancel_text (index) {
      this.departments[index].edit_mode = false
    },
    edit_user (index) {
      // this.$refs.edituser.load(index, this.users[index], this.total_space, this.total_space_remaining, this.total_space_used, this.departments)
      this.$refs.edit_user_func.load(this.users[index], index)
    },
    update_user (user, unit, index) {
      this.users[index].email = user.data.email
      this.users[index].firstname = user.data.name.first
      this.users[index].lastname = user.data.name.last
      this.users[index].phone = user.data.phone
      this.users[index].department = user.department
      this.users[index].department_id = user.data.department_id
      this.users[index].size = user.is_disable ? 'Unlimited' : user.storage
      this.users[index].unit = unit
      this.users[index].is_admin = user.data.isSuperAdmin
    },
    delete_user (index) {
      this.$refs.loading.load()
      let that = this

      let data = {
        token: cookies.getCookie('temp_token'),
        user_id: this.users[index]._id
      }

      this.$socket.emit('delete-user', data, function (data) {
        if (data.data === true) {
          that.$refs.loading.close()
          that.users.splice(index, 1)
        }

        if (data.data === false) {
          that.$router.push('login')
        }
      })
    },
    check_space_allocated () {
      if (this.unit === 'MB') {
        // If allocated size is less than 100MB
        if ((1048576 * this.size) < 104857600) {
          this.$refs.warning.load('less')
          this.size = 100
          return
        }
      }

      if (this.unit == 'GB') {
        if (this.tag != 4) {
          if (this.total_space < (1073741824 * this.size)) {
            this.$refs.warning.load('high', this.total_space)
          }
        }
      }
    },
    totalspaceremaining () {
      if (this.total_space_used > this.total_space) {
        return 0
      } else {
        return this.total_space - this.total_space_used
      }
    },
    totalspaceused () {
      this.total_space_used = this.total_user_used_space + (1048576 * this.size)
    },
    check_unit () {
      if (this.unit === 'MB') {

      } else {
        // this.total_space_remaining = 1048576 * this.size
      }
    },
    low_warning () {
      this.$refs.warning.load('low')
    },
    high_warning () {
      this.$refs.warning.load('high', this.total_space)
    },
    check_space (evt) {
      let size = this.$spaceFormat(this.total_space, this.size, this.unit)

      if (this.unit == 'MB') {
        // If allocated size is less than 100MB
        this.total_space_remaining = this.totalspaceremaining()
        this.totalspaceused()
      }

      if (this.unit === 'GB') {
        if (this.tag !== 4) {
          this.total_space_remaining = this.totalspaceremaining()
          this.totalspaceused()
        }
      }
    },
    back () {
      this.next--
    },
    skip () {
      if (this.next === 3) {
        if (this.departments.length === 0) {
          this.$refs.notify.load('Please add a department before proceeding...')
          return
        }
      }

      this.next++

      if (this.next === 4) {
        this.error.first_name = false
        this.error.last_name = false
        this.error.email = false
        this.error.password = false
        this.error.con_password = false
        this.error.password_length = false
        this.error.con_password_length = false
        this.error.user_department = false
        this.error.format = false

        let that = this
        let data = {
          token: cookies.getCookie('temp_token')
        }

        this.$socket.emit('get-departments', data, function (data) {
          if (data.data === true) {
            that.departments = data.departments
          }

          if (data.data === false) {
            that.$router.push('login')
          }
        })

        this.$socket.emit('update-step', data)
      }
    },
    go_dashboard () {
      this.$refs.loading.load()

      let data = {
        token: cookies.getCookie('temp_token')
      }

      let that = this

      AuthenticationService.go_dashbaord(data).then(res => {
        if (res.data.data === true) {
          if (process.env.VUE_APP_NODE_ENV === 'development') {
            that.$router.push('/')
          } else {
            if (
              cookies.getCookie("redirect") !== "" &&
              cookies.getCookie("redirect") !== null &&
              cookies.getCookie("redirect") !== undefined
            ) {
              window.location.replace(cookies.getCookie("redirect"));
            } else {
              window.location = "https://app.fexspace.com";
            }
          }
        } else {
          that.$router.push('/login')
        }
      })
    },
    loader () {
      this.$refs.loading.load()
    },
    close_loader () {
      this.$refs.loading.close()
    },
    add_user () {
      this.post = true

      if (this.first_name === '') {
        this.error.first_name = true
        this.post = false
      } else {
        this.error.first_name = false
      }

      if (this.last_name == '') {
        this.error.last_name = true
        this.post = false
      } else {
        this.error.last_name = false
      }

      if (this.email == '') {
        this.error.email = true
        this.post = true
      } else {
        this.error.email = false

        if (this.str.test(this.email) === false) {
          this.error.format = true
          this.post = false
        } else {
          this.error.format = false
        }
      }

      if (this.departments.length) {
        if (this.user_department == '') {
          this.error.user_department = true
          this.post = false
        } else {
          this.error.user_department = false
        }
      }

      if (this.post === true) {
        this.$refs.loading.load()

        let that = this

        let data = {
          token: cookies.getCookie('temp_token'),
          email: this.email,
          firstname: this.first_name,
          lastname: this.last_name,
          phone: this.phone,
          password: this.password,
          department: this.user_department,
          size: this.is_disable ? 'Unlimited' : this.size,
          unit: this.unit
        }

        AuthenticationService.create_user(data).then(res => {
          if (res.data.data === true) {
            that.$refs.loading.close()

            that.users.push({
              _id: data._id,
              email: that.email,
              firstname: that.first_name,
              lastname: that.last_name,
              phone: that.phone,
              department: res.data.user.department,
              department_id: that.user_department,
              size: that.is_disable ? 'Unlimited' : that.size,
              unit: that.unit,
              edit_mode: false
            })

            that.email = ''
            that.first_name = ''
            that.last_name = ''
            that.phone = ''
            that.user_department = ''
            that.is_disable = false
            that.password = ''
            that.con_password = ''
            that.size = 100
            that.unit = 'MB'
          }

          if (res.data.error == true) {
            that.$refs.loading.close()
            that.error.user_email_exist = true
          }

          if (res.data.data == false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    submit_create_department () {
      this.post = true
      this.error.department_name_exist = false

      if (this.department_name === '') {
        this.post = false
        this.error.department_name = true
      } else {
        this.error.department_name = false
      }

      if (this.post) {
        this.$refs.loading.load()

        let that = this

        let data = {
          token: cookies.getCookie('temp_token'),
          name: this.department_name,
          create_folder: this.create_folder
        }

        AuthenticationService.create_department(data).then(res => {
          if (res.data.data == true) {
            that.department_name = ''
            that.department_added = true
            that.create_folder = false
            that.$refs.loading.close()
            that.close_toastr = true

            setTimeout(function () {
              that.close_toastr = false
              that.department_added = false
            }, 3000)

            that.departments.push({
              _id: res.data.id,
              name: res.data.name,
              edit_mode: false
            })
          }

          if (res.data.exist == true) {
            that.$refs.loading.close()
            that.error.department_name_exist = true
          }

          if (res.data.result == false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    submit_company_details () {
      this.post = true

      if (this.company_name == '') {
        this.error.name = true
        this.post = false
      } else {
        this.error.name = false
      }

      if (this.country == '') {
        this.error.country = true
        this.post = false
      } else {
        this.error.country = false
      }

      if (this.post) {
        this.$refs.loading.load()
        let that = this
        let data = {
          name: this.company_name,
          phone: this.company_phone,
          address: this.company_address,
          city: this.company_address_city,
          country: this.country,
          token: cookies.getCookie('temp_token')
        }

        AuthenticationService.company_details(data).then(res => {
          if (res.data.data == true) {
            that.$refs.loading.close()
            that.next = 3
            that.close_toastr = true
            that.company_update = true
            setTimeout(function () {
              that.company_update = false
              that.close_toastr = false
            }, 3000)
          }

          if (res.data.result == false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    sendquestion (evt) {
      if (evt.keyCode === 13) {
        this.post = true

        if (this.question === '') {
          this.post = false
          this.error.question = true
        } else {
          this.error.question = false
        }

        if (this.answer === '') {
          this.post = false
          this.error.answer = true
        } else {
          this.error.answer = false
        }

        if (this.post) {
          this.$refs.loading.load()
          let that = this
          let data = {
            security_question: this.question,
            question_answer: this.answer,
            token: cookies.getCookie('temp_token'),
            account_type: this.account_type
          }

          AuthenticationService.setsecurity(data).then(res => {
            if (res.data.data == true) {
              if (that.account_type == 1) {
                that.$router.push('authenticate')
              }

              if (that.account_type == 2) {
                if (that.isStaff) {
                  // that.$refs.loading.close()
                  that.$router.push('authenticate')
                }

                if (that.isSuperAdmin) {
                  // that.$refs.loading.close()
                  that.next = 2
                }
              }
            }

            if (res.data.result == false) {
              that.$router.push('login')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    submit () {
      this.post = true

      if (this.question === '') {
        this.post = false
        this.error.question = true
      } else {
        this.error.question = false
      }

      if (this.answer === '') {
        this.post = false
        this.error.answer = true
      } else {
        this.error.answer = false
      }

      if (this.post) {
        this.$refs.loading.load()
        let that = this
        let data = {
          security_question: this.question,
          question_answer: this.answer,
          token: cookies.getCookie('temp_token'),
          account_type: this.account_type
        }

        AuthenticationService.setsecurity(data).then(res => {
          if (res.data.data == true) {
            if (that.account_type == 1) {
              // cookies.setCookie('token', res.data.token, 6 * 60 * 60 * 1000)
              // cookies.removeCookie('regtoken')
              that.$router.push('authenticate')
            }

            if (that.account_type == 2) {
              if (that.isStaff) {
                that.$refs.loading.close()
                // cookies.setCookie('token', res.data.token, 6 * 60 * 60 * 1000)
                // cookies.removeCookie('regtoken')
                that.$router.push('authenticate')
              }

              if (that.isSuperAdmin) {
                that.$refs.loading.close()
                that.next = 2
              }
            }
          }

          if (res.data.result == false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  async mounted () {
    let that = this

    localStorage.removeItem('user_id')
    localStorage.removeItem('stage')

    if (cookies.getCookie('temp_token') != '' && cookies.getCookie('temp_token') != null) {
      let data = {
        token: cookies.getCookie('temp_token')
      }

      this.$socket.emit('auth', data, (data) => {
        if (data.data == false) {
          that.$router.push('/login')
        } else {
          that.name = data.name
          that.account_type = data.account_type
          that.next = data.setup_state
          that.total_space = data.total_space
          that.tag = data.tag
          that.users = data.users
          that.isAssigned = data.isAssigned == undefined? false : data.isAssigned

          that.isSuperAdmin = data.isSuperAdmin
          that.isStaff = data.isStaff

          that.total_space_used = data.total_allocated_space

          that.total_user_used_space = data.total_allocated_space

          that.total_space_remaining = that.totalspaceremaining()

          if (data.setup_state == 4 || data.setup_state == 3) {
            let data = {
              token: cookies.getCookie('temp_token')
            }

            this.$socket.emit('get-departments', data, function (data) {
              if (data.data == true) {
                that.departments = data.departments
              }
            })
          }
        }
      })

      try {
        let { res } = await axios({
          url: process.env.VUE_APP_COUNTRY_CHECK,
          method: "GET",
        });

        if (res === undefined) {
          this.country = "";
        } else {
          this.country = res.country;
        }
      } catch(err) {
        console.log(err)
      }
    } else {
      this.$router.push('login')
    }
  }
}
</script>
